<template>
  <div class="TheLayout">
    <div class="TheLayout__topbar-container">
      <TheBanner
        v-if="showBanner"
        class="TheLayout__banner"
        @close="handleBannerClose"
      />
      <TheNavbar class="TheLayout__navbar" />
    </div>
    <main class="TheLayout__main">
      <RouterView />
    </main>
    <TheFooter class="TheLayout__footer" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import TheNavbar from '../components/ui/navigation/TheNavbar/TheNavbar.vue'
import TheFooter from '../components/ui/navigation/TheFooter/TheFooter.vue'
import TheBanner from '../components/ui/navigation/TheBanner/TheBanner.vue'

const showBanner = ref(false)

const updateTopbarHeight = () => {
  const topbarContainer = document.querySelector('.TheLayout__topbar-container')
  if (topbarContainer) {
    const height = topbarContainer.getBoundingClientRect().height
    document.documentElement.style.setProperty('--topbar-height', `${height}px`)
  }
}

onMounted(() => {
  nextTick(() => {
    updateTopbarHeight()
  })
})

// Update height when banner visibility changes
const handleBannerClose = () => {
  showBanner.value = false
  nextTick(() => {
    updateTopbarHeight()
  })
}
</script>

<style lang="scss" scoped>
.TheLayout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .TheLayout__topbar-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }

  .TheLayout__main {
    flex: 1;
    padding-top: var(--topbar-height, 0);
    overflow: hidden;
  }

  .TheLayout__container {
    width: 100%;
  }
}
</style>
